import { wOrgIdMiddleware } from '../utils/commonUtils';
import { OK } from '../utils/constant';
import http from './http';

const ReferralProviderService = {

    // Create a referral provider
    saveReferralProvider: wOrgIdMiddleware(async (url, data) => {
        try {
            const response = await http.POST(`${url}referral-provider`, data);
            return response;
        } catch (error) {
            console.error('Error saving referral provider:', error);
            if (error.status) {
                const resData = error.data;
                if (resData.code && resData.data) {
                    return resData;
                }
            }
        }
    }, true),

    // Get referral provider by ID
    getReferralProviderById: wOrgIdMiddleware(async (url, providerId) => {
        try {
            const response = await http.GET(`${url}referral-provider/${providerId}`);
            if (response.code === OK) {
                return response.data;
            } else {
                console.error('Error fetching provider:', response);
                throw new Error(response.data || 'Failed to fetch provider');
            }
        } catch (error) {
            console.error('Error in getReferralProviderById:', error);
            if (error.status) {
                const resData = error.data;
                if (resData.code && resData.data) {
                    throw new Error(resData.data);
                }
            }
            throw error;
        }
    }),

    // Get all referral providers with optional query params
    getReferralProviders: wOrgIdMiddleware(async (url, query = {}) => {
        const queryString = new URLSearchParams(query).toString();
        try {
            const response = await http.GET(`${url}referral-provider?${queryString}`);
            if (response.code === OK) {
                return response.data;
            }
        } catch (error) {
            if (error.status) {
                const resData = error.data;
                if (resData.code && resData.data) {
                    return resData;
                }
            }
        }
    }, true),

    // Update referral provider by ID
    updateReferralProvider: wOrgIdMiddleware(async (url, id, data) => {
        try {
            const response = await http.PUT(`${url}referral-provider/${id}`, data);
            if (response.code === OK) {
                return response;
            } else {
                console.error('Error updating provider:', response);
                return {
                    status: "ERROR",
                    data: response.data || 'Failed to update provider'
                };
            }
        } catch (error) {
            console.error('Error updating referral provider:', error);
            if (error.status) {
                const resData = error.data;
                if (resData.code && resData.data) {
                    return {
                        status: "ERROR",
                        data: resData.data
                    };
                }
            }
            return {
                status: "ERROR",
                data: error.message || 'Failed to update provider'
            };
        }
    }),

    // Delete referral provider by ID
    deleteReferralProvider: wOrgIdMiddleware(async (url, id) => {
        try {
            const response = await http.DELETE(`${url}referral-provider/${id}`);
            return response;
        } catch (error) {
            if (error.status) {
                const resData = error.data;
                if (resData.code && resData.data) {
                    return resData;
                }
            }
            console.error('Error deleting referral provider:', error);
            throw error;
        }
    }),
};

export default ReferralProviderService;
